<template>
  <el-card>
    <el-form inline ref="form" :model="form">
      <el-form-item prop="projectId">
        <el-select v-model="form.projectId" placeholder="请选择所属公园" filterable clearable>
          <el-option v-for="item in parkList" :key="item.projectId" :label="item.projectName" :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="mobile">
        <el-input v-model="form.mobile" placeholder="请输入游客手机号" clearable></el-input>
      </el-form-item>
      <el-form-item prop="state">
        <el-select v-model="form.state" placeholder="请选择状态" filterable clearable>
          <el-option v-for="(item, index) of stateList" :key="index" :label="item" :value="index+1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="daterange">
        <el-date-picker
          v-model="daterange"
          type="daterange"
          @change="changeDate"
          range-separator="-"
          :picker-options="pickerOptions"
          formatter="YYYY-MM-DD"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadData">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="游客手机号" show-overflow-tooltip prop="mobile" min-width="140"></el-table-column>
      <el-table-column label="反馈内容" show-overflow-tooltip prop="feedbackContent" min-width="140"></el-table-column>
      <el-table-column label="反馈时间" show-overflow-tooltip prop="ctime" min-width="140"></el-table-column>
      <el-table-column label="公园名称" show-overflow-tooltip min-width="140">
        <template v-slot="{row}">{{row.projectName || '--'}}</template>
      </el-table-column>
      <el-table-column label="状态" show-overflow-tooltip min-width="140">
        <template v-slot="{row}">
          {{row.state === 1 ? "待回复" : '已回复'}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100px">
        <template v-slot="{row}">
          <el-button type="text" @click="onDetail(row.feedbackId)">查看</el-button>
          <el-button type="text" @click="onDelete(row.feedbackId)" v-if="$ButtonShow('AUF_DEL_01')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination @size-change="loadData" @current-change="loadData" :current-page.sync="page" :total="total"></GlobalPagination>
  </el-card>
</template>

<script>
import keepAlive from '@/mixins/keepAlive.js'
export default {
  name: 'Feedback',
  mixins: [keepAlive],
  props: {},
  data () {
    return {
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      tableData: [],
      stateList: ['待回复', '已回复'], // 1待回复；2已回复
      parkList: [],
      form: {
        projectId: this.$route.query.projectId || '',
        mobile: '',
        state: '',
        startTime: this.$route.query.startTime || '',
        endTime: this.$route.query.endTime || ''
      },
      daterange: [this.$route.query.startTime || '', this.$route.query.endTime || ''],
      pickerOptions: {
        disabledDate: this.disabledDate
      }
    }
  },
  created () {
    this.loadParkList()
    this.loadData()
  },
  components: {},
  methods: {
    // 获取公园列表
    loadParkList () {
      this.$axios.get(this.$apis.project.selectYhProjectByPage, {
        projectType: '4',
        page: 1,
        size: 100,
        isCad: 0
      }).then(res => {
        this.parkList = res.list || []
      })
    },
    // 禁止选择今天之后的日期
    disabledDate (time) {
      return time.getTime() > Date.now()
    },
    changeDate (date) {
      this.form.startTime = date.length && this.$dayjs(date[0]).format('YYYY-MM-DD')
      this.form.endTime = date.length && this.$dayjs(date[1]).format('YYYY-MM-DD')
    },
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.tourist.selectAppUserFeedbackByPage, {
          page: this.page,
          size: this.size,
          ...this.form
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    onDetail (feedbackId) {
      console.log('feedbackId', feedbackId)
      this.$router.push({
        name: 'FeedbackDetail',
        params: {
          feedbackId
        }
      })
    },
    onDelete (feedbackId) {
      this.$confirm('确认删除该记录，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.tourist.deleteAppUserFeedback, {
          feedbackId
        }).then(() => {
          // console.log('删除成功')
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
